import Vue from 'vue';
import Vuex from 'vuex';

import AuthModule from './modules/AuthModule';
import ValidationModule from './modules/ValidationModule';
import SMEModule from './modules/SMEModule';
import ProviderModule from './modules/ProviderModule';
import OrganizationModule from './modules/OrganizationModule';
import CategoryModule from './modules/CategoryModule';
import CourseModule from './modules/CourseModule';
import ModuleModule from './modules/ModuleModule';
import LessonModule from './modules/LessonModule';
import EntityTaggableModule from './modules/EntityTaggableModule';
import GraphicModule from './modules/GraphicModule';
import NotificationManagementModule from './modules/NotificationManagementModule';
import FAQModule from './modules/FAQModule';
import TermsModule from './modules/TermsModule';
import CountryModule from './modules/CountryModule';
import UserModule from './modules/UserModule';
import BulkActionModule from './modules/BulkActionModule';
import DevelopmentModule from './modules/DevelopmentModule';
import CSMModule from './modules/CSMModule';
import AutomationModule from "./modules/AutomationModule";
import TimeZoneModule from './modules/TimeZoneModule';
import SessionModule from './modules/SessionModule';

Vue.use(Vuex);

export const store = new Vuex.Store({
	modules: {
		AuthModule,
		ValidationModule,
		SMEModule,
		ProviderModule,
		OrganizationModule,
		CategoryModule,
		CourseModule,
		ModuleModule,
		LessonModule,
		EntityTaggableModule,
		GraphicModule,
		NotificationManagementModule,
		FAQModule,
		TermsModule,
		CountryModule,
		UserModule,
		BulkActionModule,
		DevelopmentModule,
		CSMModule,
		AutomationModule,
		TimeZoneModule,
		SessionModule
	}
});


// WEBPACK FOOTER //
// ./src/store/store.js